import {
  showOriginalCurrencyDisclaimer,
  hideOriginalCurrencyDisclaimer,
} from '../components/paymentCurrencyDisclaimer';

const extractPrice = (priceElement) => {
  const price = priceElement.childNodes[0].textContent;
  return price;
};

const changePrice = (
  priceElement,
  { convertedPrice, selectedTargetCurrency, baseCurrency }
) => {
  priceElement.childNodes[0].textContent = convertedPrice;

  const checkoutInOriginalCurrency = baseCurrency === selectedTargetCurrency;
  if (checkoutInOriginalCurrency) {
    hideOriginalCurrencyDisclaimer();
  } else {
    showOriginalCurrencyDisclaimer();
  }
};

const matchType = (selector) =>
  selector.classList.contains('ec-cart-summary__total');

export default { matchType, extractPrice, changePrice, name: 'cartSummary' };
